import { Button } from '@react-spectrum/s2';
import type { ReactNode } from 'react';

import { AnimateIn } from '@/components/AnimateIn';

interface EmptyStateProps {
	icon: ReactNode;
	heading: string;
	subtext: string;
	ctaLabel?: string;
	onAction?: () => void;
}

export function EmptyState({
	icon,
	heading,
	subtext,
	ctaLabel,
	onAction,
}: EmptyStateProps) {
	const showCta = Boolean(ctaLabel && onAction);
	return (
		<div className="flex h-full flex-col items-center justify-center py-16">
			<AnimateIn delay={0}>
				<div className="mb-4 flex items-center justify-center">{icon}</div>
			</AnimateIn>
			<AnimateIn delay={1}>
				<h2
					className="mb-2 text-center text-2xl font-bold tracking-tight
						text-(--text-primary)"
				>
					{heading}
				</h2>
			</AnimateIn>
			<AnimateIn delay={2}>
				<p
					className="mb-8 max-w-md text-center text-sm leading-relaxed
						text-(--text-muted)"
				>
					{subtext}
				</p>
			</AnimateIn>
			{showCta && (
				<AnimateIn delay={2}>
					<Button variant="accent" onPress={onAction}>
						{ctaLabel}
					</Button>
				</AnimateIn>
			)}
		</div>
	);
}
